import { AxiosRequestConfig } from "axios";
import client from "libs/HttpClient";

/**
 * Represents the structure of a request for listing products.
 */
interface ListLicenceHistoryRequest {
  queryKey: [number, number];
}

/**
 * Service class for handling products.
 */
class LicenceHistoryService {
  static listHistory(request: ListLicenceHistoryRequest) {
    const page_no = request.queryKey[0];
    const page_size = request.queryKey[1];

    return client.get(
      `admin/licence/history/list?page=${page_no}&size=${page_size}`,
      request as AxiosRequestConfig
    );
  }
}

export { LicenceHistoryService };
